module.exports = __webpack_public_path__ + "static/img/fs.e0f71e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fs.png
// module id = O7QB
// module chunks = 0